module.exports = __webpack_public_path__ + "media/flags/lk-69d501e7.svg";